import { Injectable } from "@angular/core";
import { retry } from "rxjs/operators";

@Injectable()
export class SemHttpUtility {

  static semDecode(content: string) {
    if (content != null && typeof content != "undefined") {
      return content.replace(/%7B/g, "{").replace(/%7D/g, "}");
    }
    return "";
  }

}
